import React from 'react';

const Footer = () => {
    return (
        <>
            <div className='footer'>
                <div className="card icard">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="copyright bwf d-flex justify-content-center">
                                <p style={{fontSize: "15px", margin: 0}} >Copyright © 2026. Builders World Forum. All Rights Reserved.</p>
                            </div>
                        </div>
                        {/* <div className="col-lg-6">
                            <div className="copyright inno">
                                <a href="https://www.innoblitz.global/" style={{color:"#019342", fontSize: "15px"}} target="_blank" >Design & Developed By Innoblitz Technologies and Systems Pvt Ltd.</a>
                            </div>

                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;
